import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=bcc4f51c&scoped=true&"
import script from "./IconSelect.vue?vue&type=script&lang=js&"
export * from "./IconSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4f51c",
  null
  
)

export default component.exports